const CATEGORIES = [
  { key: "probation", label: "Probation", color: "#4A5568" },
  { key: "health", label: "Health", color: "#9C6644" },
  { key: "whanau", label: "Whānau", color: "#8B3A33" },
  { key: "mahi", label: "Mahi · work", color: "#2B4522" },
  { key: "identity", label: "Identity", color: "#D4A373" },
  { key: "other", label: "Other", color: "#6B705C" },
];

export default function GoalForm({ draft, setDraft, onCancel, onSave }) {
  return (
    <div className="bg-muka rounded-2xl p-5 border border-border space-y-3 animate-fadeup">
      <input
        placeholder="What is the whāinga?"
        value={draft.title}
        onChange={(e) => setDraft({ ...draft, title: e.target.value })}
        data-testid="goal-draft-title"
        className="w-full px-4 py-3 rounded-xl border border-border bg-bone focus:outline-none focus:ring-2 focus:ring-ngahere"
      />
      <textarea
        rows={2}
        placeholder="Notes (optional)"
        value={draft.description}
        onChange={(e) => setDraft({ ...draft, description: e.target.value })}
        data-testid="goal-draft-desc"
        className="w-full px-4 py-3 rounded-xl border border-border bg-bone focus:outline-none focus:ring-2 focus:ring-ngahere"
      />
      <div className="flex flex-wrap gap-2">
        {CATEGORIES.map((c) => (
          <button
            key={c.key}
            type="button"
            onClick={() => setDraft({ ...draft, category: c.key })}
            data-testid={`goal-cat-${c.key}`}
            className={`px-3 py-1.5 rounded-full text-xs border transition-all ${
              draft.category === c.key
                ? "border-ngahere text-ngahere bg-ngahere/10"
                : "border-border text-charcoal/70"
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>
      <input
        type="date"
        value={draft.due_date}
        onChange={(e) => setDraft({ ...draft, due_date: e.target.value })}
        data-testid="goal-draft-date"
        className="px-4 py-2.5 rounded-xl border border-border bg-bone focus:outline-none focus:ring-2 focus:ring-ngahere"
      />
      <div className="flex justify-end gap-2">
        <button
          onClick={onCancel}
          data-testid="goal-draft-cancel"
          className="px-5 py-2.5 rounded-full text-charcoal/70 hover:bg-bone"
        >cancel</button>
        <button
          onClick={onSave}
          data-testid="goal-draft-save"
          className="px-5 py-2.5 rounded-full bg-ngahere text-muka hover:bg-ngahere/90"
        >save</button>
      </div>
    </div>
  );
}
